import axios from "axios";
import store from "@/store";
import i18n from "@/lang/index";
// import {
//     apiLang
// } from "@/utils/util"
import {
    message
} from "@/utils/message.js";
var baseURL = "";
var baseURL2 = "";

if (process.env.NODE_ENV == "development") {
    // baseURL = "http://62.141.43.230:3232/rest";
    // baseURL2 = "https://www.anyviewer.com/api/v1";
    // baseURL = "https://user.anyviewer.com/rest";
    baseURL = "http://163.172.70.200:3232/rest"; // fr
    //  baseURL = "https://www.anyviewer.com/uapi/rest";
    // baseURL = "https://usertest.anyviewer.com/rest";
    // baseURL2 = "https://api.anyviewer.com/api/v1";
    // baseURL = "https://www.anyviewer.com/uapi/rest";
    baseURL2 = "https://www.anyviewer.com/ipac/api/v1/";

} else if (process.env.NODE_ENV == "production") {
    baseURL = "https://www.anyviewer.com/uapi/rest"; // huangliyun
    baseURL2 = "https://www.anyviewer.com/ipac/api/v1/"; // jiangzhangyuan
}





// 创建axios实例
const service = axios.create({
    baseURL: baseURL,
    timeout: 20000,
    headers: {
        "Content-Type": "application/json",
    },
});

// 请求拦截器
service.interceptors.request.use(
    function (config) {
        console.log(config, "+config++++++++++++++++++++++");
        // 让每个post请求携带token
        let configData = config.data ? JSON.parse(config.data) : {};
        let data = {
            ...configData,
            token: store.state.userinfo.TOKEN,
        };
        config.data = JSON.stringify(data);
        return config;
    },
    (error) => {
        // Do something with request error
        Promise.reject(error);
    }
);

//响应拦截器
service.interceptors.response.use(
    (response) => {
        /**
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
        const res = response.data;
        console.log(res, "请求入口");
        if (response.config.baseURL === baseURL) {
            if (res.code === -119 ||(res.code === 400 && res.data === "socket") ) {
                // alert("token 过期请重新登录");
                store.commit("userinfo/SIGNOUT");
                window.location.href = i18n.t("href.login");
            }
        } else if (response.config.baseURL === baseURL2) {
            if (res.data === "10013") {
                // alert("token 过期请重新登录");
                store.commit("userinfo/SIGNOUT");
                window.location.href = i18n.t("href.login");
            }
        }
        return res;
    },

    (error) => {
        console.log("err********" + error, "code", error); // for debug

        if (error.response.data.message === "Too Many Attempts." && error.response.status === 429) {
            message({
                message: i18n.t('userInfo.emailMore'),
                type: "error",
                duration: 2 * 1000,
            });
        }

        return Promise.reject(error);
    }
);

// post方法封装
export function $post(url, data) {
    return new Promise((resolve, reject) => {
        service({
                url,
                method: "post",
                data: JSON.stringify(data),
                baseURL: baseURL,
            })
            .then((res) => {
                console.log(res.orderID, "postrefasfsad");
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// post2方法封装
export function $post2(url, data) {
    return new Promise((resolve, reject) => {
        service({
                url,
                method: "post",
                data: JSON.stringify(data),
                baseURL: baseURL2,
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// 创建第三种axios实例
const service3 = axios.create({
    baseURL: "",
    timeout: 20000,
    headers: {
        "Content-Type": "multipart/form-data",
    },
});

export function $post3(url, data) {
    return new Promise((resolve, reject) => {
        service3({
                url,
                method: "post",
                data: data,
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}